/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useEffect, useRef } from 'react'
import Filter from '../../components/Filter'
import {
	Row,
	Col,
	Image,
	FormControl,
	Button,
	Modal,
	Badge,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faFileDownload,
	faChevronRight,
	faChevronLeft,
	faEye,
	faArrowRight,
} from '@fortawesome/free-solid-svg-icons'
import styles from './KioskReport.module.scss'
import EButton from '../../components/bootstrap-extended/EButton'
import 'react-day-picker/lib/style.css'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import ProfileDownload from '../../components/jobSeekers/ProfileDownload'
import dayjs from 'dayjs'
import DayPickerInput from 'react-day-picker/DayPickerInput'

interface DataProps {
  id: number;
  name: string;
  email: string;
  contact: string;
  createdAt: string;
  kiosk: string;
  avatar: string;
  counter: number;
  applicantId: number;
  url: string;
}

function useQuery() {
	const { search } = useLocation()
	return React.useMemo(() => new URLSearchParams(search), [search])
}

interface DateCSSProps {
  classNames: {
    overlayWrapper: string;
    overlay: string;
  };
  children: React.ReactNode;
}

const CustomOverlay: React.FC<DateCSSProps> = ({
	classNames,
	children,
	...props
}) => {
	return (
		<div
			className={classNames.overlayWrapper}
			style={{ marginLeft: -85 }}
			{...props}
		>
			<div className={classNames.overlay}>{children}</div>
		</div>
	)
}

const Jobseekers = () => {
	const csvLink = useRef<any | null>(null)
	const query = useQuery()

	const [applicants, setApplicants] = useState<Array<DataProps> | null>([])
	const [userDetails, setUserDetails] = useState<any>(null)
	const [startDate, setStartDate] = useState<string>('')
	const [endDate, setEndDate] = useState<string>('')
	const [filterPage, setFilterPage] = useState('')

	const [dataExport, setDataExport] = useState<any[]>([])

	const [pageNo, setPageNo] = useState('')
	const [toPage, setToPage] = useState<number>(0)
	const [isLoading, setIsLoading] = useState(true)

	const [showProfile, setShowProfile] = useState(false)

	// pagination
	const [pageCount, setPageCount] = useState(0)
	const itemsPerPage = 10

	const exportHeader = [
		{ label: 'Name', key: 'name' },
		{ label: 'Email', key: 'email' },
		{ label: 'Phone', key: 'phone' },
		{ label: 'Kiosk', key: 'kiosk' },
		{ label: 'Date', key: 'createdAt' },
	]

	const page = query.get('page')
	const startDateQuery = query.get('startDate')
	const endDateQuery = query.get('endDate')
	const typeQuery = query.get('type')
	const filters = {
		page: page !== null && parseInt(page) ? page : 1,
		startDate: startDateQuery !== null && startDateQuery ? startDateQuery : '',
		endDate: endDateQuery !== null && endDateQuery ? endDateQuery : '',
	}

	const handlePageClick = (event: { selected: number }) => {
		window.location.href = getPaginationLink((event.selected + 1).toString())
	}

	const getPaginationLink = (page: string): string => {
		return `/kiosk-report?type=${typeQuery}&page=${page}&startDate=${filters.startDate}&endDate=${filters.endDate}`
	}

	useEffect(() => {
		const getApplicants = async () => {
			try {
				const res = await axios.get(
					(process.env.REACT_APP_ROUTE_GET_KIOSK_REPORT as string) +
            `?type=${typeQuery}&page=${filters.page}&startDate=${filters.startDate}&endDate=${filters.endDate}`
				)
				setApplicants(res.data.users)
				setIsLoading(false)
				setPageCount(Math.ceil(res.data.usersAggregate / itemsPerPage))
				setPageNo(filters.page.toString())
				setStartDate(filters.startDate)
				setEndDate(filters.endDate)
			} catch (err) {
				console.log(err)
			}
		}
		getApplicants()
	}, [])

	useEffect(() => {
		if (dataExport && csvLink && csvLink.current && csvLink.current.link) {
			setTimeout(() => {
				csvLink.current.link.click()
				setDataExport([])
			})
		}
	}, [dataExport])

	useEffect(() => {
		const toNum = () => {
			if (pageNo === '') {
				setToPage(0)
			} else {
				const temp = parseInt(pageNo)
				setToPage(temp - 1)
			}
		}
		toNum()
	}, [pageNo])

	const numbersOnly = (val: string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$') //6 digits only
		if (numsCheck.test(val) || val === '') {
			setFilterPage(val)
		}
		if (parseInt(val) > pageCount) {
			setFilterPage(pageCount.toString())
		}
	}

	const submitPageNumber = () => {
		window.location.href = `/kiosk-report?type=${typeQuery}&page=${filterPage}&startDate=${filters.startDate}&endDate=${filters.endDate}`
	}

	const viewApplicantDetails = async (id: number) => {
		try {
			const res = await axios.get(
				(process.env.REACT_APP_ROUTE_GET_KIOSK_REPORT as string) +
          `/${id}?type=${typeQuery}&startDate=${filters.startDate}&endDate=${filters.endDate}`
			)
			setUserDetails(res.data.user)
			setShowProfile(true)
		} catch (err) {
			console.log(err)
		}
	}

	const handleDateChange = (
		startDateSelected: string,
		endDateSelected: string
	): void => {
		window.location.href = `/kiosk-report?type=${typeQuery}&page=${filterPage}&startDate=${startDateSelected}&endDate=${endDateSelected}`
	}

	const handleClear = () =>
		(window.location.href = `/kiosk-report?type=${typeQuery}`)

	const viewList = [
		'event-list-view',
		'event-detail-view',
		'telegram-pmet-view',
		'telegram-non-pmet-view',
		'resume-builder-view',
		'event-list-view',
		'career-assessment-tool-view',
		'location-view',
		'e-appointment-view',
		'flexi-job-vacancies-view',
		'event-networking-view',
		'event-career-view',
		'event-training-view',
		'event-opportunity-view',
		'event-all-view',
		'job-northwest-view',
		'job-northeast-view',
		'job-central-view',
		'job-southwest-view',
		'job-southeast-view',
		'virtual-northwest-view',
		'virtual-northeast-view',
		'virtual-central-view',
		'virtual-southwest-view',
		'virtual-southeast-view',
		'lhub-critical-view',
		'lhub-critical-form-view',
		'lhub-food-view',
		'lhub-food-form-view',
		'lhub-healthcare-view',
		'lhub-healthcare-form-view',
		'lhub-ict-view',
		'lhub-ict-form-view',
		'lhub-khrysalis-view',
		'lhub-khrysalis-form-view',
		'lhub-security-view',
		'lhub-security-form-view',
		'lhub-sustainability-view',
		'lhub-sustainability-form-view',
		'lhub-workplace-view',
		'lhub-workplace-form-view',
		'lhub-banner-view',
		'lhub-home-view',
		'lhub-home-form-view',
		'ntuc-home-view',
		'ntuc-referal-view',
		'ntuc-contact-view',
		'ntuc-benefit-view'
	]
	
	return (
		<div>
			<Row>
				<Col>
					<Filter />
				</Col>
			</Row>
			<Row className={styles.searchCompRow}>
				<Col lg={2} md={2} className="my-2">
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						{/* <div onClick={getAllApplicants}>
							<EButton 
								buttonText='Export'
								icon={<FontAwesomeIcon icon={faFileDownload} />} isSubmitting={false} className={styles.cusBtn}
							/>
						</div> */}
						{dataExport.length > 0 ? (
							<CSVLink
								data={dataExport}
								headers={exportHeader}
								filename={'Jobseekers.csv'}
								ref={csvLink}
							/>
						) : undefined}
					</div>
				</Col>
			</Row>
			<Row>
				<Col style={{ display: 'flex', flexFlow: 'row wrap' }}>
					<div className={styles.dateCont}>
						<div className={styles.filterDateDiv}>
							<Image src="/img/cal.png" alt="search" width="15" height="15" />
							<DayPickerInput
								formatDate={(str) => dayjs(str).format('YYYY-MM-DD')}
								onDayChange={(day) =>
									handleDateChange(dayjs(day).format('YYYY-MM-DD'), endDate)
								}
								overlayComponent={CustomOverlay}
								placeholder={'Start Date'}
								value={startDate}
							/>
						</div>
					</div>
					<div className={`d-none d-sm-block ${styles.dateArrow}`}>
						<FontAwesomeIcon icon={faArrowRight} size="xs" color="#9FB1C7" />
					</div>
					<div className={styles.dateCont}>
						<div className={styles.filterDateDiv}>
							<Image src="/img/cal.png" alt="search" width="15" height="15" />
							<DayPickerInput
								formatDate={(str) => dayjs(str).format('YYYY-MM-DD')}
								onDayChange={(day) =>
									handleDateChange(startDate, dayjs(day).format('YYYY-MM-DD'))
								}
								overlayComponent={CustomOverlay}
								placeholder={'End Date'}
								value={endDate}
							/>
						</div>
					</div>
					<div className={styles.vertical__align}>
						<Button variant="link" onClick={handleClear}>
              Clear
						</Button>
					</div>
				</Col>
			</Row>
			{/* table */}
			{/* header */}
			<div style={{ overflowX: 'auto' }}>
				<table style={{ width: '100%' }}>
					<div className={styles.tableHeader}>
						<Row className={styles.mobileViewSlideTable}>
							{[
								'Name',
								`No of ${
									typeQuery === 'login'
										? 'Login'
										: viewList.includes(typeQuery ?? '')
											? 'views'
											: 'scans'
								}`,
							].map((val, index) => (
								<Col
									key={index}
									xs={6}
									sm={index === 0 ? 8 : 2}
									className={index !== 0 ? 'text-center' : ''}
								>
									<h6>{val}</h6>
								</Col>
							))}
						</Row>
					</div>
					{/* items */}
					<div>
						{isLoading ? (
							<div className="text-center mt-3">
								<p>Loading</p>
							</div>
						) : (
							applicants &&
              applicants.map((applicant, index) => {
              	return (
              		<div
              			key={index}
              			className={styles.tableBody}
              			onClick={() => viewApplicantDetails(applicant.applicantId)}
              		>
              			<Row className={styles.mobileViewSlideTable}>
              				<Col xs={6} sm={8}>
              					<Row className="align-items-center">
              						<Col md={2} className="text-xs-start text-sm-center">
              							<Image
              								roundedCircle
              								src={
              									applicant.avatar !== null
              										? applicant.avatar
              										: 'https://dashboard.findjobs.com.sg/static/media/default_boy_avatar.dc83eae1.svg'
              								}
              								style={{
              									width: '70px',
              									height: '70px',
              									margin: '16px',
              								}}
              							/>
              						</Col>
              						<Col>
              							<div className="p-3 p-sm-0">
              								<h5>{applicant.name}</h5>
              								<small style={{ display: 'block' }}>
              									{applicant.email !== null ? (
              										<span>{applicant.email}</span>
              									) : (
              										<span> - </span>
              									)}
              									{applicant.contact !== null && (
              										<span> | {applicant.contact}</span>
              									)}
              								</small>
              								<Badge bg="secondary">{applicant.kiosk}</Badge>
              							</div>
              						</Col>
              					</Row>
              				</Col>
              				<Col
              					xs={6}
              					sm={2}
              					className="d-flex align-items-center justify-content-center"
              				>
              					<p>{applicant.counter}</p>
              				</Col>
              				<Col
              					xs={3}
              					sm={2}
              					className="d-none d-sm-flex align-items-center justify-content-center"
              				>
              					<Button
              						className={styles.filterBtn}
              						onClick={() =>
              							viewApplicantDetails(applicant.applicantId)
              						}
              					>
              						<FontAwesomeIcon icon={faEye} />
              						<span className="ps-2">Details</span>
              					</Button>
              				</Col>
              			</Row>
              		</div>
              	)
              })
						)}
					</div>
				</table>
			</div>

			<Row style={{ marginTop: '20px' }}>
				<Col />
				<Col>
					<ReactPaginate
						containerClassName={styles.pagination}
						previousClassName="page-item"
						nextLinkClassName="page-link"
						// activeClassName="active"
						activeLinkClassName={styles.paginationActive}
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						breakLinkClassName="page-link"
						breakClassName="page-item"
						previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
						pageCount={pageCount}
						onPageChange={handlePageClick}
						nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
						pageRangeDisplayed={3}
						marginPagesDisplayed={3}
						breakLabel="..."
						forcePage={toPage}
						// renderOnZeroPageCount={null}
					/>
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<span
						style={{ fontSize: '14px', color: '#5B7493', paddingTop: '5px' }}
					>
            Go to page
					</span>
					<FormControl
						style={{
							width: '15%',
							display: 'inline-block',
							margin: '0 10px',
							height: '35px',
						}}
						onChange={(e) => {
							numbersOnly(e.target.value)
						}}
						value={filterPage}
					/>
					<Button
						onClick={submitPageNumber}
						variant="primary"
						className={styles.cusBtn}
					>
            Go
					</Button>
				</Col>
			</Row>

			<Modal
				show={showProfile}
				size="lg"
				onHide={() => {
					setShowProfile(false)
				}}
			>
				<Modal.Header closeButton className="border-0" />
				<Modal.Body className="px-5 pt-0">
					{userDetails && (
						<>
							<Row>
								<Col xs={4} sm={2} className="text-center">
									<Image
										roundedCircle
										src={
											userDetails.avatar !== null
												? userDetails.avatar
												: 'https://dashboard.findjobs.com.sg/static/media/default_boy_avatar.dc83eae1.svg'
										}
										style={{
											width: '70px',
											height: '70px',
											marginTop: '10px',
											marginBottom: '10px',
										}}
									/>
								</Col>
								<Col xs={8} className="d-flex align-items-center">
									<div>
										<h5>{userDetails.name}</h5>
									</div>
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={6} sm={3}>
									<p>
										<span>Contact</span> <br />
										<span>Email</span> <br />
									</p>
								</Col>
								<Col>
									<p>
										<span>
											{userDetails.contact ? userDetails.contact : '-'}
										</span>{' '}
										<br />
										<span>
											{userDetails.email ? userDetails.email : '-'}
										</span>{' '}
										<br />
									</p>
								</Col>
							</Row>
							<hr />
							<p>
								<strong>
									{typeQuery === 'login'
										? 'Login History'
										: viewList.includes(typeQuery ?? '')
											? 'Page View History'
											: 'Qr Scan History'}
								</strong>
							</p>
							<div className="overflow-scroll" style={{ height: '400px' }}>
								{userDetails.history.map((his: any, i: number) => {
									if (
										typeQuery !== 'login' &&
                    typeQuery !== 'event-detail-view'
									) {
										return (
											<Row key={i}>
												<Col md={4}>
													<p>
														{moment(his.createdAt).format(
															'DD MMM YYYY, h:mm a'
														)}
													</p>
												</Col>
												<Col md={3}>
													<p>
														<strong>{his.kiosk}</strong>
													</p>
												</Col>
												{his.url && (
													<Col md={5}>
														<a href={his.url} target="_blank" rel="noreferrer">
															<p>{his.url}</p>
														</a>
													</Col>
												)}
											</Row>
										)
									} else if (typeQuery === 'event-detail-view') {
										return (
											<Row key={i}>
												<Col md={4}>
													<p>
														{moment(his.createdAt).format(
															'DD MMM YYYY, h:mm a'
														)}
													</p>
												</Col>
												<Col md={3}>
													<p>
														<strong>{his.kiosk}</strong>
													</p>
												</Col>
												<Col md={5}>
													<p>{his.title}</p>
												</Col>
											</Row>
										)
									}
									return (
										<Row key={i}>
											<Col>
												<p>
													{moment(his.createdAt).format('DD MMM YYYY, h:mm a')}
												</p>
											</Col>
											<Col>
												<p>
													<strong>{his.kiosk}</strong>
												</p>
											</Col>
										</Row>
									)
								})}
							</div>
						</>
					)}
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default Jobseekers
